import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('memberStateNames', app)

  store.getters.activeStates = (state) => {
    return state.list.default.data.filter((item) => {
      return !item.marksEnd
    })
  }
  return store
}
